import { useTranslation } from "react-i18next";
import { FileUpload, SectionHeading } from "../../../components";

export const Select = () => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeading
        title={t("upload.select.title")}
        subtitle={t("upload.select.subtitle")}
      />
      <FileUpload />
    </>
  )
}